import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import Modal from "./Modal";

const modalRoot = document.getElementById("portal-root");

class Portal extends React.Component {
	render() {
		return (
			<Fragment>
				{ReactDOM.createPortal(<Modal {...this.props} />, modalRoot)}
			</Fragment>
		);
	}
}

export default Portal;
